export default [
  {
    text: 'Продажа',
    value: 'sale',
  },
  {
    text: 'Переуступка права аренды',
    value: 'leaseAssignment',
  },
];
